import { useContext } from 'react';

// Components
import { DropdownListItem } from '@/components/DropdownListItem/DropdownListItem';
import { Context } from '@/components/Store';
// Modules
import { warn } from '@/lib/log';

type DropdownProps = {
  dropdownType: 'zipCodes' | 'cities' | 'streets';
  id: string;
};

const Dropdown = (props: DropdownProps) => {
  const [state] = useContext(Context);
  let listItems;

  if (props.dropdownType && state?.autocompletions) {
    const items = state.autocompletions[props.dropdownType];

    switch (props.dropdownType) {
      case 'zipCodes':
      case 'cities': {
        if (items && items.length > 0) {
          listItems = items.map((item, index) => {
            // Type narrowing: items is zipCodes or cities array
            const cityItem = item as { name: string; zipCode: string; district?: string };
            return (
              <DropdownListItem
                data-city={cityItem.name}
                data-type={props.dropdownType}
                data-zip={cityItem.zipCode}
                key={`${index}-${props.dropdownType}-dropdown`}
              >
                {cityItem.district ? `${cityItem.zipCode} ${cityItem.name} (${cityItem.district})` : `${cityItem.zipCode} ${cityItem.name}`}
              </DropdownListItem>
            );
          });
        }
        break;
      }

      case 'streets': {
        if (items && items.length > 0 && state.address?.delivery) {
          listItems = items.map((item, index) => {
            // Type narrowing: items is streets array
            const streetItem = item as { name: string; streetNumber: string };
            return (
              <DropdownListItem
                data-city={state.address?.delivery.city}
                data-street={streetItem.name}
                data-street-id={streetItem.streetNumber}
                data-type={props.dropdownType}
                data-zip={state.address?.delivery.zip}
                key={`${index}-${props.dropdownType}-dropdown`}
              >
                {streetItem.name}
              </DropdownListItem>
            );
          });
        }
        break;
      }

      default:
        warn('Fallthrough case, no dropdowns populated');
    }
  }

  return (
    <datalist
      className="form--datalist u-scrollbar"
      id={props.id}
    >
      {listItems}
    </datalist>
  );
};

export { Dropdown };
